import { FelaCSS, TColor, colors } from '@bridebook/ui';

interface IStyles {
  button: FelaCSS;
}

const styles = (
  size: number,
  border?: boolean,
  borderColor?: TColor,
  boxShadow?: boolean,
  backgroundColor?: TColor,
  customBackgroundColor?: string,
  hasOnClick?: boolean,
  disabled?: boolean,
): IStyles => ({
  button: {
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: customBackgroundColor || colors[backgroundColor || 'space04'],
    border: `1px solid ${border ? colors[borderColor || 'space40'] : 'transparent'}`,
    borderRadius: '100%',
    boxShadow: boxShadow ? '0px 0px 3px rgba(0, 0, 0, 0.15)' : 'none',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: disabled ? 'none' : 'all',
    opacity: disabled ? 0.5 : 1,
    cursor: hasOnClick ? 'pointer' : 'inherit',
    padding: 0,
  },
});

export default styles;
